/**
 * Brand context - separated to comply with react-refresh rules.
 */

import { createContext } from 'react'
import type { UseBrandSwitcherReturn } from './useBrandSwitcher.js'

export const BrandContext = createContext<UseBrandSwitcherReturn | null>(null)
